import produce from 'immer';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { initialStates } from '../initial-states/initialStates';
import { SessionState } from '../initial-states/stateTypes';

const initialState = initialStates.session.normalState;

const reducer = produce(
  (state: SessionState = initialState, action: Action) => {
    switch (action.type) {
      case ActionType.UPDATE_DHL_API_TOKEN:
        state.dhlApiToken = action.payload;
        return state;
      case ActionType.UPDATE_DHL_AGENT_TOKEN:
        state.dhlAgentToken = action.payload;
        return state;
      case ActionType.UPDATE_DHL_API_TOKEN_EXPIRATION_TIME:
        state.tokenExpirationTime = action.payload;
        return state;
      case ActionType.UPDATE_DHL_API_TOKEN_EXPIRED:
        state.tokenExpired = action.payload;
        return state;
      case ActionType.RESET_DHL_API_TOKEN:
        state.dhlApiToken = '';
        return state;
      case ActionType.UPDATE_NEEDS_SESSION_OPEN:
        state.needsSessionOpen = action.payload;
        return state;
      case ActionType.UPDATE_AUTHENTICATING:
        state.authenticating = action.payload;
        return state;
      case ActionType.UPDATE_AUTH_ERROR_MESSAGE:
        state.authErrorMessage = action.payload;
        return state;
      case ActionType.UPDATE_NEEDS_LOGIN:
        state.needsLogin = true;
        return state;
      case ActionType.SESSION_EXIT_SHOW_MODAL:
        state.showExitModal = action.payload;
        return state;
      case ActionType.USER_INACTIVITY_SHOW_MODAL:
        state.showUserInactivityModal = action.payload;
        return state;
      case ActionType.UPDATE_USER_INACTIVITY_SECONDS:
        state.userInactivitySeconds = action.payload;
        return state;
      case ActionType.SESSION_RESET:
        return initialState;
      default:
        return state;
    }
  },
  initialState
);

export default reducer;
